import { v4 as uuid } from "uuid";
import dayjs from "dayjs";

export class Folder {
  constructor({ id, name, created_at }) {
    this.id = id || uuid();
    this.name = name;
    this.created_at = created_at || dayjs().toISOString();
    this.isNew = !id;
  }
}
